import { useState, useEffect } from "react"
import styles from "../../../../../styles/Participant-Employment.module.css"
import CheckboxField from "../../../Utils/CheckboxField"
const PastEducationExperiencesCheckboxForm = ({
  label,
  setValue,
  valueName,
  value,
  callback,
}) => {
  const [selected, setSelected] = useState({
    arabic: value?.arabic,
    chineseCambodian: value?.chineseCambodian,
    chuukese: value?.chuukese,
    hmong: value?.hmong,
    laotian: value?.laotian,
    russian: value?.russian,
    spanish: value?.spanish,
    tagalog: value?.tagalog,
    cambodian: value?.cambodian,
    chineseMandarin: value?.chineseMandarin,
    english: value?.english,
    korean: value?.korean,
    marshallese: value?.marshallese,
    somali: value?.somali,
    swahili: value?.swahili,
    vietnamese: value?.vietnamese,
    other: value?.other,
  })

  useEffect(() => {
    setValue(valueName, selected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected])

  return (
    <>
      <label className={styles.label}>{label}</label>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexBasis: "100%",
            flex: "1",
            color: "#383838",
          }}
        >
          <CheckboxField
            label={"Arabic"}
            value={selected}
            setValue={setSelected}
            valueName={"arabic"}
          />
          <CheckboxField
            label={"Chinese Cambodian"}
            value={selected}
            setValue={setSelected}
            valueName={"chineseCambodian"}
          />
          <CheckboxField
            label={"Chuukese"}
            value={selected}
            setValue={setSelected}
            valueName={"chuukese"}
          />
          <CheckboxField
            label={"Hmong"}
            value={selected}
            setValue={setSelected}
            valueName={"hmong"}
          />
          <CheckboxField
            label={"Laotian"}
            value={selected}
            setValue={setSelected}
            valueName={"laotian"}
          />
          <CheckboxField
            label={"Russian"}
            value={selected}
            setValue={setSelected}
            valueName={"russian"}
          />
          <CheckboxField
            label={"Spanish"}
            value={selected}
            setValue={setSelected}
            valueName={"spanish"}
          />
          <CheckboxField
            label={"Tagalog"}
            value={selected}
            setValue={setSelected}
            valueName={"tagalog"}
          />
          <CheckboxField
            label={"Other"}
            value={selected}
            setValue={setSelected}
            valueName={"other"}
            callback={callback}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexBasis: "100%",
            flex: "1",
            color: "#383838",
          }}
        >
          <CheckboxField
            label={"Cambodian"}
            value={selected}
            setValue={setSelected}
            valueName={"cambodian"}
          />
          <CheckboxField
            label={"Chinese Mandarin"}
            value={selected}
            setValue={setSelected}
            valueName={"chineseMandarin"}
          />
          <CheckboxField
            label={"English"}
            value={selected}
            setValue={setSelected}
            valueName={"english"}
          />
          <CheckboxField
            label={"Korean"}
            value={selected}
            setValue={setSelected}
            valueName={"korean"}
          />
          <CheckboxField
            label={"Marshallese"}
            value={selected}
            setValue={setSelected}
            valueName={"marshallese"}
          />
          <CheckboxField
            label={"Somali"}
            value={selected}
            setValue={setSelected}
            valueName={"somali"}
          />
          <CheckboxField
            label={"Swahili"}
            value={selected}
            setValue={setSelected}
            valueName={"swahili"}
          />
          <CheckboxField
            label={"Vietnamese"}
            value={selected}
            setValue={setSelected}
            valueName={"vietnamese"}
          />
        </div>
      </div>
    </>
  )
}
export default PastEducationExperiencesCheckboxForm
